<div class="container-fluid">
  <page-header-breadcrumb
  [pageTitleValue]="pageTitle"
  [pageLinkValue]="'/test-request'"
  [currentPageValue]="'Test Result'"
></page-header-breadcrumb>

  <div class="card mb-4">
    <div class="card-body">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <br />
            <form>
              <div class="custom-file">
                <input
                  (change)="onImageUpload($event)"
                  class="custom-file-input"
                  id="offer-image"
                  lang="en"
                  type="file"
                  accept=".jpg,.png"
                />

                <label class="custom-file-label" for="offer-image">
                  {{ imageFile ? imageFile.name : "Select file" }}
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col btns-block">
          <button
            class="btn btn-primary"
            type="button"
            (click)="onAddLatestOffer()"
          >
            {{ editMode ? "Edit" : "Save" }}
          </button>
          <button
            class="btn btn-outline-danger"
            type="button"
            [routerLink]="'/services'"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
